import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutNotificationDrawerService {
  private readonly openSignal = signal(false);

  /** When true, the notification drawer should be visible. */
  readonly drawerOpen = this.openSignal.asReadonly();

  open(): void {
    this.openSignal.set(true);
  }

  close(): void {
    this.openSignal.set(false);
  }
}
